import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import 'react-notifications-component/dist/theme.css';
import { Button, Col, Input, Row } from "reactstrap";
import { bibleAction } from '../../actions/bibleAction';
import { readingAction } from '../../actions/readingAction';
import { showAlert } from "../common/functions";
import { EditableDropdown, DABBackToList, LoadingSpinnerModal, DABHtmlEditor } from '../../components/dab';

interface IBibleProps {
	dispatch: Dispatch<any>;
	readingData: any;
	callback: any;
	id: number;
	bibleData: any;
}

const ReadingDetail: React.SFC<IBibleProps> = ({
	dispatch, readingData, bibleData, callback, id }) => {
	var biblesInput = {
		title: "",
		bibleId: -1
	}

	const history = useHistory();

	const [isBibleListLoaded, setIsBibleListLoaded] = useState(false); 
	const [formSubmit, setformSubmit] = useState(false); 
	const [content, setContent] = useState(""); 
	const [isPreviewPage, setIsPreviewPage] = useState(false); 
	const [input, setInput] = useState(biblesInput);
	const [bibleId, setBibleId] = useState(-1);
	const [bibleTitle, setBibleTitle] = useState(-1); 
	const [showModal, setShowModal] = useState(false); 
	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const initialBibleObject = [{ text: "", value: -1, checked: false }];
	const [bibleList, setBibleList] = useState(initialBibleObject); 
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 
	const [isReadingListLoaded, setIsReadingListLoaded] = useState(true); 
	const [readingTitleList, setReadingTitleList] = useState(initialBibleObject); 
	const [readingList, setReadingList] = useState(initialBibleObject);
	const [isDirty, setIsDirty] = useState<boolean>(false)
	
	const handleHtmlContentChange = (evt) => {
		setContent(evt.getData());
	}

	function handleGetReadingBasedonBible(bibleId) {		
		setIsReadingListLoaded(false)
		if (!showModal) {
			setShowModal(true);
		}		
		setBibleId(bibleId);
		dispatch(readingAction.radingTitleGetExcludeByBible({ bibleIds: [bibleId]}));

	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === '') { return; }
		if (name === "bibleId") {
			setInput({
				...input,
				[name]: (value && value !== null && value !== "") ? parseInt(value) : -1
			});
			handleGetReadingBasedonBible(parseInt(value));
		}
		else {
			setInput({
				...input,
				[name]: value
			});
		}
		setIsDirty(true)
	};

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setformSubmit(true);
		setShowModal(true);
		dispatch(readingAction.readingSave({ reading: input }));
		setIsErrorOnPage(false);
	};


	React.useEffect(() => {
		if (!isBibleListLoaded) {
			const initBibleInputValue = {
				languageCodes: [] as string[],
				uniqueCodes: [] as string[],
				pageNumber: 1,
				pageSize: 100,
				sortColumn: "",
				sortDirection: "asc",
				isCommonFilter: false,
				isLanguageFilter: false
			};
			dispatch(bibleAction.bibleGetByFilter(initBibleInputValue));
		}
		if (id >= 0) {
			dispatch(readingAction.readingGetDetail(id));
		}
		setShowModal(true);
	}, []);

	if (bibleList && !isBibleListLoaded) {
		if (bibleData.items.length > 0) {
			var list: any[] = [];
			bibleData.items.sort((a: any, b: any) => a.title?.localeCompare(b.title)).forEach((data) => {
				var item = { text: data.title + " (" + data.uniqueCode + ")", value: data.bibleId, checked: true };
				list.push(item);
			});
			setBibleList(list);
			setInput({
				...input,
				bibleId: -1
			});
			setIsBibleListLoaded(true);
			setShowModal(false)
		}
	}

	if (readingData) {
		if (readingList && !isReadingListLoaded) {
			if (readingData.isTitleListSuccess) {
				readingData.isTitleListSuccess = false;
				if (readingData.items.length > 0) {
					var list1: any[] = [];
					var strlist: any[] = [];
					list1.push({ text: "", value: -1, checked: false });
					readingData.items.forEach((data) => {
						var item = { text: data.title, value: data.title, checked: true };
						list1.push(item);
						strlist.push(data.title);
					});
					setReadingList(list1);
					setReadingTitleList(strlist);
				}
				setIsReadingListLoaded(true);
				if (showModal) {
					setShowModal(false);
				}
			}
		}
		
		if (readingData.isError && !readingData.isSuccess) {
			setShowModal(false);
			if (readingData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(readingData.status, true);
			}
			setIsErrorOnPage(true);
			readingData.isError = false;
		}

		if (formSubmit && readingData.isSuccess && !isErrorOnPage) {
			window.localStorage.setItem('alertMessage', readingData.status);
			window.location.href = "/reading?id=" + readingData.reading.readingId
			readingData.isSuccess = false;
		}
		
		if (readingData.isDetailComplete) {
			if (!isDetailLoaded && readingData.readingsInput) {
				if (readingData.readingsInput && readingData.readingsInput !== null) {
					setInput(readingData.readingsInput);
					if (readingData.readingsInput.contentHtml !== null && readingData.readingsInput.contentHtml !== "")
					{
						setContent(readingData.readingsInput.contentHtml);
					}
					else {
						setContent("");
					}					
					setIsDetailLoaded(true);
					handleGetReadingBasedonBible(parseInt(readingData.readingsInput.bibleId));
					setShowModal(false);
				}
			}
		}
		if (isDetailLoaded && isBibleListLoaded && bibleData.isListSuccess && readingData.isDetailComplete) {
			if (id > 0) {
				var title = bibleData.items.find(x => x.bibleId == bibleId)?.title;
				callback(title + " - " + readingData.readingsInput.title);
			}			
			setBibleTitle(title);
			readingData.isDetailComplete = false;
		}

		if (readingData.isUpdateText && readingData.isSuccess && !readingData.isError) {
			window.localStorage.setItem('alertMessage', readingData.status);
			window.location.reload()
		}		
	}

	const handleUpdateReadingText = (e) => {
		e.preventDefault();
		dispatch(readingAction.readingTextUpdate({reading: {readingId: id}}))
	}

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="reading-detail" data-testid="readingDetailList">
			<div className='card-box'>
				{!isDetailLoaded && !isPreviewPage && (
					<form name="createform" onSubmit={handleSubmit} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="Bibleuage" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblBible">Bible</label>
							<div className={["col-sm-5"].join(" ")} data-testid="bibleContainer">
								<Input type="select" className="form-select" id="bibleId" name="bibleId"
									value={input.bibleId} onChange={(event) => { handleInputChange(event); }}>
									<option value="">--- Select ---</option>
									{bibleList && bibleList.map((data: any) =>
											<option key={data.value} value={data.value}>{data.text}</option>)}
								</Input>
							</div>
						</div>

						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblReadingTitle">Reading Title</label>
							<div className={["col-sm-5"].join(" ")} data-testid="readingTitleContainer">
								<EditableDropdown value={input.title} idValue="title" oldValue={input.title} onChange={handleInputChange} suggestions={readingTitleList} maxLength={100} />
							</div>
						</div>
						{/*<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblReadingText">Reading Text</label>
							<div className={["col-sm-5"].join(" ")} data-testid="readingTextContainer">
								{content !== null && (<DABHtmlEditor content={content} onChange={handleHtmlContentChange} id="description" />)}
							</div>
						</div>*/}
						<br />
						<br />
						<br />
						<Row className="rdc-buttons">
							<Col lg="3" data-testid="cancelButtonContainer">
								<Button className="" onClick={(e) => { handleBackClick(e); }}>CANCEL</Button>
							</Col>
							<Col lg="3" data-testid="createButtonContainer">
								<Button type="submit" className="btn-submit-frm" value="Next">CREATE</Button>
							</Col>
						</Row>
					</form>)}

				{isDetailLoaded && id <= 0 && (
					<form name="createformEdit" onSubmit={handleSubmit} className="reading-update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="Bibleuage" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditBible">Bible</label>
							<div className={["col-sm-5"].join(" ")} data-testid="bibleContainer">
								<Input key={"bibleId" + bibleId} type="select" className="form-select" id="bibleId" required
									name="bibleId" value={bibleId} onChange={(event) => { handleInputChange(event) }}>
									{
										bibleList && bibleList.map((data: any) =>
											<option key={data.value} value={data.value}>{data.text}</option>
										)}
								</Input>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditReadingTitle">Reading Title</label>
							<div className={["col-sm-5"].join(" ")} data-testid="readingTitleContainer">
								<EditableDropdown value={input.title} idValue="title" oldValue={input.title} onChange={handleInputChange} suggestions={readingTitleList} maxLength={100} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditReadingText">Reading Text</label>
							<div className={["col-sm-5"].join(" ")} data-testid="readingTextContainer">
								{content !== null && (<DABHtmlEditor content={content} onChange={handleHtmlContentChange} id="description" />)}
							</div>
						</div>

						<Row className="rdu-buttons">
							<Col lg="11" className={["pull-right"].join(" ")} data-testid="updateButtonContainer">
								<Button type="submit" className="btn-submit-frm">SAVE CHANGES</Button>
							</Col>
						</Row>
					</form>
				)}
				{isDetailLoaded && id > 0 && (
					<form name="createformEdit" onSubmit={handleUpdateReadingText} className="reading-update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="Bibleuage" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditBible">Bible</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="bibleContainer">
								{bibleTitle}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditReadingTitle">Reading Title</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="readingTitleContainer">
								{input.title}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblEditReadingText">Reading Text</label>

							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="readingTextContainer" dangerouslySetInnerHTML={{ __html: content }}>
							</div>
						</div>
						<Row className="rdu-buttons">
							<Col lg="11" className={["pull-right"].join(" ")} data-testid="updateReadingText">
								<Button type="submit" className="btn-submit-frm">Update Reading Text</Button>
							</Col>
						</Row>
					</form>
				)}
			</div>
			{(showModal || readingData.isLoading) && (<LoadingSpinnerModal isShowModal={showModal || readingData.isLoading} modalChange={handleLoadShowModal} />)}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { bibleData, readingData } = state;
	return {
		readingData, bibleData
	};
};

export default connect(mapStateToProps)(ReadingDetail);
